import { Dashboard, Ads } from '@/components';
import { CATALOG_ADS_PER_PAGE } from '@/components/Ads/constants';

export const RentPage = () => (
  <Dashboard isSearch openLogIn>
    <Ads adsPerPage={CATALOG_ADS_PER_PAGE} enableAmbassadorPromotion enableTopAgentFilter isRent />
  </Dashboard>
);
